import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  mode: "history", // 启用history模式
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/solution",
      redirect: "/solution/pc"
    },
    {
      path: "/solution/pc", //pc
      name: "solutionPC",
      component: resolve => require(["../view/solution/pc"], resolve)
    },
    {
      path: "/solution/mobile", //手机
      name: "solutionMobile",
      component: resolve => require(["../view/solution/mobile"], resolve)
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/routePage/PageView"], resolve),
      children: [
        {
          path: "/",
          name: "home",
          component: () => import("@/view/home/HomePage.vue"),
          meta: {
            title: "首页"
          }
        },
        {
          path: "/AI",
          name: "AI-root",
          component: resolve => require(["../view/routePage/Ai"], resolve),
          meta: {
            title: "AI"
          },
          children: [
            {
              path: "chatDeepSeek",
              name: "AI-DS",
              component: resolve =>
                require(["../view/ai/ChatDS"], resolve),
              meta: {
                title: "AI丨 DeepSeek"
              }
            },
          ]
        },
        {
          path: "/software",
          name: "software-root", // 唯一命名
          component: resolve =>
            require(["../view/routePage/Software"], resolve),
          meta: { title: "软件产品" },
          children: [
            {
              path: "/software",
              redirect: "panoVR"
            },
            {
              path: "panoVR", // 相对路径
              name: "software-panoVR", // 唯一命名
              component: resolve =>
                require(["../view/software/panoVR"], resolve),
              meta: {
                title: "软件产品丨南图全景系列"
              }
            },
            {
              path: "gisPublicPlatform",
              name: "software-gis",
              component: resolve =>
                require(["@/view/software/gisPublicPlatform"], resolve),
              meta: {
                title: "软件产品丨南图地理信息公共平台"
              }
            },
            {
              path: "digital3D", // 相对路径
              name: "software-digital3D",
              component: () => import("@/view/software/digital3D.vue")
            },
            {
              path: "3dPlan",
              name: "software-3dPlan",
              component: resolve =>
                require(["@/view/software/3dPlan"], resolve),
              meta: {
                title: "软件产品丨三维路径规划"
              }
            },
            {
              path: "3DModel",
              name: "software-3DModel",
              component: resolve =>
                require(["@/view/software/3DModel"], resolve),
              meta: {
                title: "软件产品丨三维模型展示"
              }
            }
          ]
        },
        {
          path: "/solution",
          name: "solution-root", // 唯一命名
          component: resolve =>
            require(["../view/routePage/Solution"], resolve),
          meta: { title: "解决方案" },
          children: [
            {
              path: "pc",
              name: "solution-pc",
              component: resolve => require(["@/view/solution/pc"], resolve),
              meta: { title: "解决方案丨地理信息公共平台" }
            },
            {
              path: "AE",
              name: "solution-AE",
              component: resolve =>
                require(["@/view/solution/ServiceDetail"], resolve),
              meta: {
                title: "解决方案丨AE辅助生产工具"
              }
            },
            {
              path: '/solution/servicedetail',
              name: 'GIS',
              component: resolve => require(['@/view/solution/ServiceDetail'], resolve),
              meta: {
                title: '解决方案丨南图GIS服务平台'
              }
            },
            {
              path: '/solution/servicedetail',
              name: 'Smart',
              component: resolve => require(['@/view/solution/ServiceDetail'], resolve),
              meta: {
                title: '解决方案丨南图智慧平台'
              }
            }
          ]
        },
        {
          path: "/service",
          name: "service",
          component: resolve => require(["@/view/home/Service"], resolve),
          meta: {
            title: "相关服务"
          }
        },
        // {
        //   path: '/newsinformation',
        //   name: 'newsinformation',
        //   component: resolve => require(['@/view/NewsInformation'], resolve),
        //   meta: {
        //     title: '新闻动态'
        //   }
        // },

        {
          path: "/company",
          name: "company-root",
          component: resolve => require(["../view/routePage/company"], resolve),
          meta: {
            title: "公司介绍"
          },
          children: [
            {
              path: "/company",
              redirect: "/company/introduction"
            },
            {
              path: "introduction",
              name: "company-introduction",
              component: resolve =>
                require(["../view/company/Introduction"], resolve),
              meta: {
                title: "公司介绍丨公司简介"
              }
            },
            {
              path: "qualifications",
              name: "company-qualifications",
              component: resolve =>
                require(["../view/company/qualifications"], resolve),
              meta: {
                title: "公司介绍丨企业资质"
              }
            },
            {
              path: "jobchance",
              name: "company-jobchance",
              component: resolve => require(["@/view/company/JobChance"], resolve),
              meta: {
                title: "工作机会"
              }
            },
          ]
        },

        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/us/ContactUs"], resolve),
          meta: {
            title: "联系我们"
          }
        },
        {
          path: "/servicedetail",
          name: "servicedetail",
          component: resolve =>
            require(["@/view/solution/ServiceDetail"], resolve),
          meta: {
            title: "相关服务"
          }
        }
      ]
    },
    // 添加通配符回退路由
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js